/*
 * Búsquedas recientes (snippets/cv-search-history.liquid): cada búsqueda que llega a /search?q=…
 * (desde el header, el buscador de la portada, las sugerencias o las búsquedas populares) se guarda
 * en localStorage.cv_search_history, solo en este navegador. Al tocar un buscador
 * (form.search-bar) se despliegan debajo; al escribir, se filtran por el texto. La lista va en
 * <body> con posición fija bajo el buscador: dentro del header quedaba debajo de la barra del mega
 * menú, y el buscador de la portada la recortaba (overflow: hidden).
 */
(function () {
  'use strict';

  var KEY = 'cv_search_history';
  var MAX = 5;
  var uid = 0;

  function clean(q) {
    return String(q || '').replace(/\s+/g, ' ').trim().slice(0, 100);
  }

  function read() {
    try {
      var list = JSON.parse(window.localStorage.getItem(KEY) || '[]');
      if (!Array.isArray(list)) return [];
      // slice: quien ya tenía más guardadas (antes eran 8) ve solo las últimas MAX.
      return list.filter(function (q) { return typeof q === 'string' && clean(q); }).slice(0, MAX);
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      if (list.length) window.localStorage.setItem(KEY, JSON.stringify(list));
      else window.localStorage.removeItem(KEY);
    } catch (e) {}
  }

  function without(list, q) {
    var low = q.toLowerCase();
    return list.filter(function (x) { return x.toLowerCase() !== low; });
  }

  function add(q) {
    q = clean(q);
    if (!q) return;
    var list = without(read(), q);
    list.unshift(q);
    write(list.slice(0, MAX));
  }

  function remove(q) {
    write(without(read(), clean(q)));
  }

  function clear() {
    write([]);
  }

  function queryFromUrl(search) {
    var m = String(search || '').match(/[?&]q=([^&#]*)/);
    if (!m) return '';
    try {
      return decodeURIComponent(m[1].replace(/\+/g, ' '));
    } catch (e) {
      return '';
    }
  }

  function searchUrl(q) {
    return '/search?q=' + encodeURIComponent(q) + '&type=product';
  }

  var CLOCK = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><polyline points="12 7 12 12 15 14"/></svg>';
  var CLOSE = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><line x1="6" y1="6" x2="18" y2="18"/><line x1="18" y1="6" x2="6" y2="18"/></svg>';

  function attach(input) {
    if (input.getAttribute('data-cv-sh')) return;
    input.setAttribute('data-cv-sh', '1');
    var host = input.closest('.search-bar__top-wrapper') || input.parentNode;
    var box = document.createElement('div');
    box.className = 'cv-sh';
    box.id = 'cv-sh-' + (++uid);
    box.hidden = true;
    document.body.appendChild(box);
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-controls', box.id);
    input.setAttribute('aria-expanded', 'false');

    var shown = [];
    var active = -1;

    function place() {
      var r = host.getBoundingClientRect();
      box.style.top = Math.round(r.bottom + 6) + 'px';
      box.style.left = Math.round(r.left) + 'px';
      box.style.width = Math.round(r.width) + 'px';
      box.style.maxHeight = Math.max(160, Math.min(360, window.innerHeight - r.bottom - 16)) + 'px';
    }

    function hide() {
      box.hidden = true;
      active = -1;
      input.setAttribute('aria-expanded', 'false');
    }

    // Al tocar el buscador va la lista completa (en producto el header ya trae la última búsqueda
    // escrita); al escribir, solo las que contienen el texto.
    function matches(filter) {
      var typed = filter ? clean(input.value).toLowerCase() : '';
      var list = read();
      if (!typed) return list;
      return list.filter(function (q) {
        var low = q.toLowerCase();
        return low !== typed && low.indexOf(typed) !== -1;
      });
    }

    function render(filter) {
      shown = matches(filter === true);
      active = -1;
      if (!shown.length) return hide();
      box.innerHTML = '';

      var head = document.createElement('div');
      head.className = 'cv-sh__head';
      var title = document.createElement('span');
      title.textContent = 'Búsquedas recientes';
      var clearBtn = document.createElement('button');
      clearBtn.type = 'button';
      clearBtn.className = 'cv-sh__clear';
      clearBtn.textContent = 'Borrar todo';
      clearBtn.addEventListener('click', function () {
        clear();
        hide();
        input.focus();
      });
      head.appendChild(title);
      head.appendChild(clearBtn);
      box.appendChild(head);

      var ul = document.createElement('ul');
      ul.className = 'cv-sh__list';
      ul.setAttribute('role', 'listbox');
      shown.forEach(function (q, i) {
        var li = document.createElement('li');
        li.className = 'cv-sh__row';
        li.setAttribute('role', 'option');
        var a = document.createElement('a');
        a.className = 'cv-sh__item';
        a.href = searchUrl(q);
        a.innerHTML = CLOCK;
        var text = document.createElement('span');
        text.textContent = q;
        a.appendChild(text);
        a.addEventListener('click', function () { add(q); });
        var rm = document.createElement('button');
        rm.type = 'button';
        rm.className = 'cv-sh__remove';
        rm.setAttribute('aria-label', 'Quitar "' + q + '" del historial');
        rm.innerHTML = CLOSE;
        rm.addEventListener('click', function () {
          remove(q);
          render(false);
          input.focus();
        });
        li.appendChild(a);
        li.appendChild(rm);
        li.setAttribute('data-index', i);
        ul.appendChild(li);
      });
      box.appendChild(ul);
      place();
      box.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function highlight(i) {
      var rows = box.querySelectorAll('.cv-sh__row');
      if (!rows.length) return;
      active = (i + rows.length) % rows.length;
      for (var k = 0; k < rows.length; k++) rows[k].classList.toggle('is-active', k === active);
    }

    input.addEventListener('focus', function () { render(false); });
    input.addEventListener('click', function () { if (box.hidden) render(false); });
    input.addEventListener('input', function () { render(true); });
    input.addEventListener('blur', function () { setTimeout(function () { if (document.activeElement !== input) hide(); }, 150); });
    input.addEventListener('keydown', function (e) {
      if (box.hidden) {
        if (e.key === 'ArrowDown') render(false);
        return;
      }
      if (e.key === 'ArrowDown') { e.preventDefault(); highlight(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); highlight(active - 1); }
      else if (e.key === 'Escape') { hide(); }
      else if (e.key === 'Enter' && active >= 0 && shown[active]) {
        e.preventDefault();
        add(shown[active]);
        window.location.href = searchUrl(shown[active]);
      }
    });
    // Que el clic en la lista no quite el foco al buscador antes de llegar al enlace o al botón.
    box.addEventListener('mousedown', function (e) { e.preventDefault(); });
    function follow() { if (!box.hidden) place(); }
    window.addEventListener('scroll', follow, { passive: true });
    window.addEventListener('resize', follow);
    // Si se abre un panel del mega menú, la lista no queda encima de él.
    document.addEventListener('mouseover', function (e) {
      if (!box.hidden && e.target.closest && e.target.closest('.cmm-nav-bar')) hide();
    });
  }

  function init() {
    var inputs = document.querySelectorAll('form.search-bar input[name="q"]');
    for (var i = 0; i < inputs.length; i++) attach(inputs[i]);
  }

  if (/^\/search\/?$/.test(window.location.pathname)) add(queryFromUrl(window.location.search));

  window.CvSearchHistory = { read: read, add: add, remove: remove, clear: clear, queryFromUrl: queryFromUrl };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
